import React, {useState, useEffect} from 'react'
import {Redirect} from 'react-router-dom'
import {ServerConfig} from 'config'
import axios from 'axios'
import {useSelector} from 'react-redux'

import loading_gif from '../../assets/img/loading.gif'

import {makeStyles} from '@material-ui/core/styles'
import {Typography, Grid, Button, TextField, Select, MenuItem, FormControl, InputLabel} from '@material-ui/core'
import InfoBanner from 'components/common/InfoBanner'


const useStyles = makeStyles((theme) => ({}))

const RIG3Report = () => {
  const token = useSelector(state => state.auth.access_token)

  const [certIds, setCertIds] = useState([])
  const [selectedCertId, setSelectedCertId] = useState('')
  const [grantNumber, setGrantNumber] = useState('')

  const now = new Date()
  const defaultMonthValue = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`
  const [monthValue, setMonthValue] = useState(defaultMonthValue)

  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState(null)

  const classes = useStyles()

  async function fetchCertIds() {
    const config = {headers: {'Content-Type': 'application/json'}}
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }

    const results = await axios.get(`${ServerConfig.SERVER_URL}/tenant/machines`, config)
    const uniqueCertIds = [...new Set(results.data.map(m => m.cert_id).filter(Boolean))]
    setCertIds(uniqueCertIds)
    if (uniqueCertIds.length > 0) {
      setSelectedCertId(uniqueCertIds[0])
    }
  }

  useEffect(() => {
    fetchCertIds()
  }, [token])

  async function request_download(token) {
    setIsLoading(true)
    setError(null)

    const config = {
      responseType: 'blob',
      headers: {
        'Content-Type': 'application/json',
        'Accept': "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      },
    }

    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }

    const [year, month] = monthValue.split('-').map(Number)

    const body = JSON.stringify({
      cert_id: selectedCertId,
      grant_number: grantNumber,
      year: year,
      month: month,
    })

    var filename;

    axios.post(`${ServerConfig.SERVER_URL}/tenant/rig3_report_excel`, body, config)
      .then(response => {
        const disposition = response.headers['content-disposition'];
        filename = disposition.split(/;(.+)/)[1].split(/=(.+)/)[1];

        if (filename.toLowerCase().startsWith("utf-8''")) {
          filename = decodeURIComponent(filename.replace("utf-8''", ''));
        } else {
          filename = filename.replace(/['"]/g, '');
        }
        return response.data;
      })
      .then(response_data => {
        let blob = new Blob([response_data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'})
        var url = window.URL.createObjectURL(blob);
        var a = document.createElement('a');
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        a.remove();
      })
      .catch(error => {
        console.error(error);
        if (error.response && error.response.data) {
          // error responses are JSON, not a blob, when the request failed validation
          error.response.data.text().then(text => {
            try {
              setError(JSON.parse(text).message || 'Failed to generate report.')
            } catch (e) {
              setError('Failed to generate report.')
            }
          })
        } else {
          setError('Failed to generate report.')
        }
      })
      .finally(() => {
        setIsLoading(false)
      });
  }

  if (!token) {
    return <Redirect to="/login"/>
  }

  return (
    <>
      <Grid container spacing={3}>
        <InfoBanner
          title={"RIG3 Daily Collection Report"}
          items={[
            <>One report covers a single Certification Number (site) and a single month</>,
            <>Generates the official CalRecycle RIG3 template, filled with your transaction data for that month</>
          ]}
        />
        <Grid item xs={12} sm={3}>
          <FormControl fullWidth>
            <InputLabel>Certification Number</InputLabel>
            <Select value={selectedCertId} onChange={e => setSelectedCertId(e.target.value)}>
              {certIds.map(certId => (
                <MenuItem key={certId} value={certId}>{certId}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={12} sm={3}>
          <TextField
            fullWidth
            label="Grant Number"
            value={grantNumber}
            onChange={e => setGrantNumber(e.target.value)}
          />
        </Grid>

        <Grid item xs={12} sm={3}>
          <TextField
            fullWidth
            label="Month"
            type="month"
            value={monthValue}
            onChange={e => setMonthValue(e.target.value)}
            InputLabelProps={{shrink: true}}
          />
        </Grid>

        <Grid item xs={12} sm={3} style={{display: 'flex', alignItems: 'center'}}>
          <Button
            onClick={() => request_download(token)}
            disabled={!selectedCertId || !monthValue || isLoading}
          >
            Download
          </Button>
        </Grid>

        {error &&
          <Grid item xs={12}>
            <Typography style={{color: 'red'}}>{error}</Typography>
          </Grid>
        }

        {isLoading &&
          <Grid item xs={12}>
            <img src={loading_gif} style={{'width': '150px'}}/>
          </Grid>
        }
      </Grid>
    </>
  )
}

export default RIG3Report
